<template>
    <footer
        class="md-footer layout1"
        :class="[{ inner: inner }]"
        :style="{
            ...colorStyle,
            ...spaceStyle,
            backgroundColor: bgColor
        }"
    >
        <div class="footer-container" :style="{ color: fontColor }">
            <div class="top-content">
                <div class="top-inner" :class="{ 'f-col': !inner }">
                    <div class="agent-logo">
                        <div class="logo-wrap">
                            <div class="site-logo" v-if="logos.length > 0">
                                <template v-for="(logo, index) in validLogos">
                                    <a
                                        v-if="logo.logo.href"
                                        :key="index"
                                        :href="logo.logo.href"
                                        aria-label="site logo"
                                        rel="noopener noreferrer"
                                    >
                                        <site-img
                                            class="logo-item"
                                            :src="logo.logo"
                                            alt="site logo"
                                            :style="{
                                                height: size / 100 + 'em'
                                            }"
                                            :ssrInitSize="30"
                                            dir="height"
                                        />
                                    </a>
                                    <site-img
                                        v-else
                                        class="logo-item"
                                        :key="'key-' + index"
                                        :src="logo.logo"
                                        alt="site logo"
                                        :style="{ height: size / 100 + 'em' }"
                                        :ssrInitSize="30"
                                        dir="height"
                                    />
                                </template>
                            </div>
                            <closely-app-download
                                useModule="md-footer"
                                :downloadTheme="true"
                            />
                        </div>
                        <div class="agent-wrap">
                            <div
                                v-if="companyInfo?.name"
                                class="co-name"
                                :style="footerBroNameStyle"
                                v-html="companyInfo.name"
                            ></div>
                            <div class="agent-detail">
                                <div
                                    v-if="
                                        footerAgentInfo?.firstName ||
                                            footerAgentInfo?.lastName
                                    "
                                    class="agent-name"
                                    :style="{
                                        ...footerAgentInfoStyle
                                    }"
                                >
                                    {{ footerAgentInfo.firstName || '' }}
                                    {{ footerAgentInfo.lastName || '' }}
                                </div>
                                <div class="agent-info">
                                    <div
                                        v-if="footerAgentInfo?.phone"
                                        class="detail-phone agent-item"
                                        :style="footerAgentInfoStyle"
                                    >
                                        <a
                                            :href="
                                                'tel:' + footerAgentInfo.phone
                                            "
                                            target="_top"
                                            rel="noopener noreferrer"
                                        >
                                            <i class="iconfont icon-phone1"></i>
                                            <span class="text">
                                                {{
                                                    $ft.formatPhone(
                                                        footerAgentInfo.phone
                                                    )
                                                }}
                                            </span>
                                        </a>
                                    </div>
                                    <div
                                        v-if="footerAgentInfo?.email"
                                        class="detail-email agent-item"
                                        :style="footerAgentInfoStyle"
                                    >
                                        <a
                                            :href="
                                                'mailto:' +
                                                    footerAgentInfo.email
                                            "
                                            :title="$t('common:link.mailtoTitle')"
                                            :aria-label="
                                                $t('common:link.mailtoAriaLabel', {
                                                    email: footerAgentInfo.email
                                                })
                                            "
                                            rel="noopener noreferrer"
                                        >
                                            <i
                                                class="iconfont icon-v5-email"
                                            ></i>
                                            <span class="text">
                                                {{ footerAgentInfo.email }}
                                            </span>
                                        </a>
                                    </div>
                                    <div
                                        v-if="getAddressInfo"
                                        class="detail-addr agent-item"
                                        :style="footerBroAddrStyle"
                                    >
                                        <i class="iconfont icon-address1"></i>
                                        <span
                                            class="text"
                                            v-html="getAddressInfo"
                                        ></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="detail-wrap"
                        v-if="
                            subOwnerInfo ||
                                footerAgentCustomContent ||
                                agentHasDisclaimer ||
                                subOwnerHasDisclaimer
                        "
                    >
                        <div
                            class="detail subdomain-detail"
                            v-if="subOwnerInfo"
                        >
                            <p
                                class="detail-info subinfo-name"
                                v-if="subOwnerName"
                            >
                                <span v-text="subOwnerName" class="detail-name">
                                </span>
                            </p>
                            <p class="detail-info">
                                <span
                                    v-if="subOwnerInfo?.phone"
                                    class="detail-phone"
                                >
                                    <a
                                        :href="'tel:' + subOwnerInfo.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >
                                        {{
                                            $ft.formatPhone(subOwnerInfo.phone)
                                        }}
                                    </a>
                                </span>
                            </p>
                            <p class="detail-info">
                                <span
                                    v-if="subOwnerInfo?.email"
                                    class="detail-email"
                                >
                                    <a
                                        :href="'mailto:' + subOwnerInfo.email"
                                        :title="$t('common:link.mailtoTitle')"
                                        :aria-label="
                                            $t('common:link.mailtoAriaLabel', {
                                                email: subOwnerInfo.email
                                            })
                                        "
                                        rel="noopener noreferrer"
                                    >
                                        {{ subOwnerInfo.email }}
                                    </a>
                                </span>
                            </p>
                        </div>

                        <div
                            class="detail other-cont"
                            v-if="footerAgentCustomContent"
                        >
                            <div
                                class="custom-content"
                                v-html="
                                    formatFontSize(footerAgentCustomContent)
                                "
                            ></div>
                        </div>
                        <div
                            class="detail-info"
                            v-if="agentHasDisclaimer || subOwnerHasDisclaimer"
                        >
                            <template v-if="agentHasDisclaimer">
                                <p
                                    v-for="(
                                        file, index
                                    ) in footerAgentInfo.disclaimerList"
                                    :key="index + 'mainfile'"
                                    class="detail-file"
                                >
                                    <a
                                        :href="file.url"
                                        rel="noopener noreferrer"
                                    >
                                        {{ file.name.split('.')[0] }}
                                    </a>
                                </p>
                            </template>
                            <!-- sub file -->
                            <template v-if="subOwnerHasDisclaimer">
                                <p
                                    v-for="(
                                        file, index
                                    ) in subOwnerInfo.disclaimerList"
                                    :key="index + 'subfile'"
                                    class="detail-file"
                                >
                                    <a
                                        :href="file.url"
                                        rel="noopener noreferrer"
                                    >
                                        {{ file.name.split('.')[0] }}
                                    </a>
                                </p>
                            </template>
                        </div>
                    </div>
                    <ul class="menu-wrap main-menu" role="navigation" v-if="!isMobile">
                        <menu-item
                            v-for="(menu, index) in z_menus"
                            :key="index"
                            :selfKey="'menu-' + index"
                            :expandKey="expandKey"
                            :menu="menu"
                            :useMenuStyle="footerMenuStyle"
                            :useSubMenuStyle="footerSubMenuStyle"
                            @update-expand-key="updateExpandKey"
                        />
                    </ul>
                    <div
                        v-if="socialNetworksInfo.length > 0"
                        class="share-links"
                    >
                        <a
                            v-for="(social, index) in socialNetworksInfo"
                            :key="social.id + '-' + index"
                            class="share-item"
                            :href="social.url"
                            :aria-label="social.socialNetwork"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i class="iconfont" :class="social.icon"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div
                class="bottom-content"
                :style="{ backgroundColor: botBgColor }"
            >
                <div class="bottom-inner" :class="{ 'f-col': !inner }">
                    <MlsDisclaimer
                        v-if="!wordPressSSR"
                        theme="layout1"
                        @update="mlsUpdated"
                    />

                    <div class="no-mls-disclaimer texas-mls" v-if="hasTeaxsMls">
                        <a
                            href="https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-3.pdf"
                            target="_blank"
                            :title="$t('md-footer.realEstateConsumer')"
                            rel="noopener noreferrer"
                        >{{ $t('md-footer.realEstateConsumer') }}</a>
                    </div>
                    <div
                        class="no-mls-disclaimer"
                        v-if="noMlsDisclaimers.length > 0"
                    >
                        <div
                            class="claimer"
                            v-for="(noMls, index) in noMlsDisclaimers"
                            :key="index"
                            v-html="noMls.label"
                        ></div>
                    </div>
                    <a class="md-footer_notshare" v-if="isDoNotShareShow" href="/site/dsar">{{ $t('md-footer.doNotShare') }} --&gt; </a>
                    <div v-if="!hideCopyRight" class="copyright">
                        <template v-if="gfFlag != '1'">
                            <p
                                class="cr"
                                v-if="showCopyright"
                                v-html="
                                    $t('md-footer.madeInAndCopyright', {
                                        chimeLink,
                                        year
                                    })
                                "
                            ></p>
                            <p class="ppt">
                                <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                            </p>
                        </template>
                        <p v-else class="cr">
                            {{ $t('md-footer.geographicFarmingLlc', { year }) }}
                            <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import common from '../index-layout';
export default {
    name: 'MdFooterLayout1',
    mixins: [common],
    data: function() {
        return {};
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import '../index.scss';

.md-footer.layout1 {
    color: var(--g-primary-color);

    &.fixed {
        position: fixed;
        bottom: 0;
        width: 100%;
    }
    .footer-container {
        position: relative;
    }

    .top-content {
        padding: 80px 0;
        .agent-logo {
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;

            .logo-wrap {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                gap: 30px;
                .site-logo {
                    font-size: 50px;
                    overflow: hidden;
                    position: relative;
                    .logo-item {
                        margin-right: 40px;
                        height: 1em;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }

                .download-closely {
                    display: flex;
                    flex-direction: column-reverse;
                    gap: 10px;
                    .code-title {
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 21px;
                        text-align: center;
                        margin-bottom: 0;
                        color: var(--g-tip-color);
                    }
                    .code-wrapper {
                        .android {
                            margin-left: 30px;
                        }

                        .android,
                        .ios {
                            img {
                                width: 80px;
                                height: 80px;
                            }
                        }

                        justify-content: flex-start;

                        .qr-code {
                            border-radius: 0;
                        }
                    }
                }
            }

            .agent-wrap {
                display: flex;
                flex-direction: column;
                gap: 20px;
                .co-name,
                .agent-name {
                    font-size: 24px;
                    line-height: 36px;
                    text-align: left;
                }

                .agent-detail {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }

                .agent-info {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;

                    .agent-item {
                        font-size: 15px;
                        font-weight: 400;
                        line-height: 22.5px;
                        text-align: left;
                        .icon-v5-email {
                            font-size: 13px;
                        }
                        .text {
                            margin-left: 10px;
                        }
                    }
                }
            }
        }
        .detail-wrap {
            margin-top: 30px;
            .detail {
                &.subdomain-detail,
                &.other-cont {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 21px;
                    text-align: left;
                }
                &.subdomain-detail {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    > span {
                        vertical-align: top;
                    }
                }
                &.other-cont {
                    margin-top: 20px;
                }
            }

            > .detail-info {
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                gap: 10px;
                .detail-file {
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 21px;
                    text-align: left;
                }
            }

            @include no-mls-disclaimer;
        }
        .menu-wrap {
            margin-top: 40px;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            column-gap: 20px;
            .menu-item {
                padding-left: 0;
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                text-align: left;
                @include ellipsis;

                .footer-submenu {
                    margin-top: 10px;
                    .sub-menu {
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 30px;
                        text-align: left;
                        > a {
                            position: relative;
                            &:before {
                                content: ' ';
                                position: absolute;
                                left: 0%;
                                right: unset;
                                bottom: 2px;
                                top: unset;
                                height: 1px;
                                width: 0%;
                                background-color: var(--g-primary-color);
                                -webkit-transition: width 0.3s ease;
                                transition: width 0.3s ease;
                            }
                            &:hover:before {
                                width: 100%;
                            }
                        }
                    }
                }
            }
            .icon-arrow-down {
                margin-left: 10px;
                font-size: 12px;
            }
        }
        .share-links {
            margin-top: 40px;
            font-size: 0px; // remove inline-block spacing
            display: flex;
            flex-wrap: wrap;
            gap: 15px;

            .share-item {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                border: 1px solid var(--g-primary-color);
                .iconfont {
                    font-size: 14px;
                    color: var(--g-primary-color);
                }
                &:hover {
                    background: var(--g-primary-color);
                    .iconfont {
                        color: var(--bg-color);
                    }
                }
            }
        }
    }

    .bottom-content {
        padding: 50px 0;

        .mls-declaimer-container-v2 {
            padding-top: 0;
            .declaimer {
                display: flex;
                flex-direction: column-reverse;
                gap: 15px;
                align-items: flex-start;
                .content {
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 20px;
                    text-align: left;
                    color: rgba(255, 255, 255, 0.6);
                }
                .mls-logo {
                    margin-top: 0;
                }
            }
        }

        .copyright {
            margin-top: 30px;
            font-size: 12px;
            font-weight: 400;
            line-height: 20px;
            text-align: left;
            color: var(--g-tip-color);

            .cr {
                line-height: 20px;
                a {
                    text-decoration: underline;
                }
            }

            .ppt {
                margin-top: 10px;
                line-height: 20px;
                a {
                    white-space: nowrap;
                }
            }
        }
    }

    &.inner {
        .top-content {
            padding: 80px var(--inner-padding, 20px);
            .agent-logo {
                gap: 20px;
                .logo-wrap {
                    flex: 1;
                    .site-logo {
                        display: flex;
                        justify-content: flex-end;
                        flex-wrap: wrap;
                        gap: 20px;
                        .logo-item {
                            margin-right: 0;
                        }
                    }
                }
                .agent-wrap {
                    flex: 1;
                }
            }
            .menu-wrap {
                display: grid;
                grid-template-columns: repeat(3, minmax(200px, 1fr));
                grid-column-gap: 20px;
                grid-row-gap: 30px;
            }
        }
        .bottom-content {
            padding: 50px var(--inner-padding, 20px);
        }
    }

    .fair-house-logo {
        vertical-align: text-bottom;
        margin: 0 5px;
        padding-top: 5px;
    }

    @mixin media-600-footer {
        .top-content {
            padding: 40px 0;
            .agent-logo {
                flex-direction: column;
                gap: 30px;

                .logo-wrap {
                    align-items: flex-start;
                    gap: 20px;
                    .site-logo {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 20px;
                        .logo-item {
                            margin-right: 0;
                        }
                    }

                    .download-closely {
                        flex-direction: column;
                        .code-title {
                            line-height: 18px;
                            text-align: left;
                        }
                    }
                }

                .agent-wrap {
                    .co-name,
                    .agent-name {
                        font-size: 18px;
                        line-height: 27px;
                    }
                }
            }

            .share-links {
                margin-top: 30px;
            }
        }

        .bottom-content {
            padding: 25px 0 40px;

            .copyright {
                margin-top: 20px;
            }
        }
    }

    @include media-600 {
        @include media-600-footer();
    }
}
</style>
